export const HIDE_BALANCE_KEY = 'HIDE_BALANCE';
export const LAST_USED_APP = 'lastUsedProduct';
